const getters = {
    getServiceRequestLaborsList(state) {
        return state.serviceRequestLabors;
    }
}

export default getters